/**
 * Custom Filters - Fan Collection
 * Template-specific configuration for the fan-collection template (passes the `collection` param)
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // The API collection slug comes from the collection's `subcategory` metafield
  // (e.g. "fans-led"), exposed on the body as data-subcategory. This lets a collection
  // point at a different API slug than its URL handle without a hardcoded mapping.
  // Fall back to the URL handle when the metafield isn't set.
  const subcategorySlug = (document.body.dataset.subcategory || '').trim();
  const apiParamValue = subcategorySlug || collectionHandle;

  // Initialize with collection-specific config.
  // The collection slug is passed to the filter API via the `collection` param.
  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    apiParamName: 'collections',
    apiParamValue: apiParamValue,
    excludedFilters: ['categories', 'subcategories', 'collections', 'locations', 'trends', 'motorTypes'],
    extraApiParams: {}
  });
});
